<template>
    <b-container>
        <template v-if="$options.components['advertisement-loading']">
            <advertisement-loading v-if="isLoading" />
        </template>
      <b-row v-if="!isLoading">
        <b-col class="my-4">
          <div class="main-banner">
            <img
              :src="sampleCollectionBannerImage.icon && sampleCollectionBannerImage.icon.fileUrl || ''"
              alt="Sample Collection Market Banner"
            />
          </div>
          <b class="">Category</b>
          <sections-slider
            v-if="list && list.length"
            :list="list"
            subTitle="Health Care"
            :hasInnerBackground="true"
            :hasButton="false"
            :withSlider="true"
          >
            <template slot="default" slot-scope="{ listItem }">
              <div class="item-box">
                <items-item
                  :itemLogo="true"
                  :product="listItem"
                  :incrementDecrementKey="false"
                  :marketRoute="{
                    name:
                      listItem.name == 'Health Care'
                        ? `health-care`
                        : `healthcare-market-view`,
                    params: {
                      market: listItem.name,
                      id: listItem._id,
                      items: listItem.externalAttributes,
                    },
                  }"
                ></items-item>
              </div>
            </template>
          </sections-slider>
          <sections-slider
            :list="itemSuggestions"
            subTitle="Top Booked Test"
            :showTitle="true"
            :hasBackground="false"
            :hasButton="true"
            class="suggested-slider"
            :withSlider="true"
            :viewMorePage="{
              name: `health-care-listing`,
              params: {
                items: `Most Popular`,
              },
            }"
          >
            <template slot="default" slot-scope="{ listItem }">
              <div class="item-box ml-2 mr- 2">
                <items-item
                  :itemNoBg="true"
                  :product="listItem"
                  :incrementDecrementKey="true"
                  class="suggester-div"
                ></items-item>
              </div>
            </template>
          </sections-slider>
          <sections-slider
            :list="newArrivals"
            subTitle="Test Packages"
            :showTitle="true"
            :hasBackground="false"
            :hasButton="true"
            class="suggested-slider"
            :withSlider="true"
            :viewMorePage="{
              name: `health-care-listing`,
              params: {
                items: `Daily Essentials`,
              },
            }"
          >
            <template slot="default" slot-scope="{ listItem }">
              <div class="item-box ml-2 mr- 2">
                <items-item
                  :itemNoBg="true"
                  :product="listItem"
                  :incrementDecrementKey="true"
                  class="suggester-div"
                ></items-item>
              </div>
            </template>
          </sections-slider>
        </b-col>
      </b-row>
    </b-container>
  </template>
  
  <script>
  import { mapState } from "vuex";
  
  export default {
    data() {
      return {
        isLoading: false,
      };
    },
    computed: {
      ...mapState({
        list: (state) => state.healthCare.specificItemsList,
        itemSuggestions: (state) => state.healthCare.itemSuggestions,
        newArrivals: (state) => state.healthCare.newArrivals,
        sampleCollectionBannerImage: (state) => state.healthCare.marketBanner,
      }),
    },
    methods: {},
  
    async mounted() {
      this.isLoading = true;
      let payload = {
        city: "GHATAL",
        placement: "MARKET_TOP",
        market: this.$route.params.marketid,
      };
      await this.$store.dispatch("healthCare/fetchMarketBanner", payload);
      // await this.$store.dispatch(
      //   "healthCare/fetchSpecificItemsList",
      //   this.$route.params.marketid
      // );
  
      await this.$store.dispatch(
        "healthCare/fetchAllItems",
        this.$route.params.market
      );
      this.isLoading = false;
    },
  
    created() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  };
  </script>
  
  <style scoped>
  .main-banner{
    border-radius: 8px;
    margin-bottom: 20px;
  }
  .main-banner img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
  </style>